// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import Vant from 'vant'
import 'vant/lib/index.css'
import './assets/font/iconfont.css'

import Video from 'video.js'
import 'video.js/dist/video-js.css'

import { Lazyload } from 'vant';
import { PullRefresh, List, Dialog ,Toast,DatetimePicker,RadioGroup, Radio} from 'vant'

Vue.use(Vant)
Vue.use(Lazyload)
Vue.use(PullRefresh).use(List).use(Dialog)
.use(Toast).use(DatetimePicker).use(RadioGroup).use(Radio)

Vue.prototype.$video = Video
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
  
})

// 返回定位
router.afterEach((to,from) => {
    let path = to.name;
    //判断需要定位的路由地址
    if(path == 'equipment' || path =='equipmentList'){
//      //获取储存起来的位置
//      let scrollTop = localStorage.getItem('scrollTop');
//      if(scrollTop || scrollTop =="0"){
//      	 
//          setTimeout(()=>{
//              //页面渲染完成后，在滚动，位置才是正确的，所以加个延迟
//              console.log(scrollTop)
//              document.documentElement.scrollTop =  parseInt(scrollTop) ;
//              //document.getElementById('app').scrollTop = scrollTop; 
//              localStorage.setItem('scrollTop',0);   //定位后还原储存位置信息
//              localStorage.setItem('pIndex',1);
//              
//              localStorage.setItem('pIndex1',1);
//          },1000)
//      }
    }else{
        //除了特定地址，其他的都返回顶部
        //let currentTop =  sessionStorage.getItem('scrollTop');// document.getElementById('app').scrollTop;
        //sessionStorage.setItem('scrollTop', currentTop*1);//储存位置
        //document.documentElement.scrollTop =  0;
        
        //document.getElementById('app').scrollTop = 0; 
    }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js